import { pxToRem } from '../../../../utils';
export default (function (siteVariables) {
  return {
    avatarBorderColor: '',
    avatarBorderWidth: '0',
    squareAvatarBorderRadius: pxToRem(3),
    statusBorderColor: siteVariables.bodyBackground,
    statusBorderWidth: '2px',
    iconColor: siteVariables.colors.white,
    iconBackgroundColor: siteVariables.colors.brand[600]
  };
});
//# sourceMappingURL=avatarVariables.js.map
